import { render, staticRenderFns } from "./DsnTable.vue?vue&type=template&id=cbd80b42&"
import script from "./DsnTable.vue?vue&type=script&lang=js&"
export * from "./DsnTable.vue?vue&type=script&lang=js&"
import style0 from "./DsnTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports